import {CDN_URL} from 'common/src/config/consts';

export const ICONS_BASE_URL = `${CDN_URL}/a_icons`;

export default function createIconsObj<G extends Record<string, unknown>>(
  iconsObjData: G,
  iconsBasePath?: string,
) {
  function proxyHandler(
    target: Record<string, unknown>,
    prop: string,
  ): string | Record<string, unknown> {
    const data = target[prop];
    if (!data) return undefined;
    if (typeof data === 'string')
      return (iconsBasePath ? ICONS_BASE_URL + '/' + iconsBasePath : ICONS_BASE_URL) + target[prop];

    return new Proxy(data as Record<string, unknown>, {get: proxyHandler});
  }

  return new Proxy(iconsObjData, {get: proxyHandler}) as G;
}
